import { render, staticRenderFns } from "./ClaimList.vue?vue&type=template&id=b5f19c72&"
import script from "./ClaimList.vue?vue&type=script&lang=js&"
export * from "./ClaimList.vue?vue&type=script&lang=js&"
import style0 from "./ClaimList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ClaimList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports